import React from "react";
import AccessTypeFormContent from "../../../../../../components/common/PL/Forms/AccessTypeFormContent/AccessTypeFormContent";

type ContractorContentFormProps = {
  formId: string;
  authorizations?: any[];
  disabled?: boolean;
};

const ContractorContentForm: React.FC<ContractorContentFormProps> = ({
  formId: _formId,
  authorizations,
  disabled = false,
}) => (
  <AccessTypeFormContent fieldPrefix="contractor" authorizations={authorizations} disabled={disabled} />
);

export default ContractorContentForm;
